<template>
    <form autocomplete="off">
        <q-toggle
            v-model="details.enabled"
            label="Включен"
        />
        <q-field>
            <q-input
                v-model="details.requisites.public_key"
                stack-label="Public key"
            />
        </q-field>
        <q-field>
            <q-input
                v-model="details.requisites.private_key"
                stack-label="Private key"
            />
        </q-field>
        <div class="q-mt-lg row justify-end items-center">
            <div>
                <q-btn
                    @click="save()"
                    :loading="saving"
                    label="Сохранить"
                    color="primary"
                />
                <q-btn
                    @click="$emit('close')"
                    color="primary"
                    flat
                    label="Закрыть"
                />
            </div>
        </div>
    </form>
</template>

<script>
import harvester from './mixins/harvester'

import { QBtn, QField, QInput, QToggle } from 'quasar'

export default {
    name: 'LiqpayMethod',
    components: {
        QField,
        QInput,
        QToggle,
        QBtn,
    },
    mixins: [
        harvester,
    ],
    props: {
        provider: Object,
        details: {
            type: Object,
            default () {
                return {
                    enabled: false,
                    payment_method: 'liqpay',
                    requisites: {
                        public_key: '',
                      private_key: '',
                    },
                }
            },
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PaymentMethodEdit/methods/LiqpayMethod.vue